import React, { useEffect } from 'react';
import styles from './StripeInfo.module.scss';

/* Factory */
import { useStripeInfo } from './__hooks__/useStripeInfo';

/* Stripe Elements */
import { CardElement, injectStripe } from 'react-stripe-elements';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';

/* Providers */
import { useBuyerContext } from '../../../__providers__/BuyerProvider';
import { usePaymentTypeContext } from '../../../__providers__/PaymentTypeContext';
import { useLoadingContext } from '../../../__providers__/LoadingProvider';

const StripeInfo: React.FC<any> = ({ stripe, elements }) => {
  const { t } = useTranslation();
  const {
    states: { name, setName },
  } = useBuyerContext();
  const {
    states: {
      setCardElementComplete,
      cardElementComplete,
      cardHolderComplete,
      setCardHolderComplete,
    },
  } = useStripeInfo();
  const { setPaymentHandler, setOptions } = usePaymentTypeContext();
  const { setLoading } = useLoadingContext();

  useEffect(() => {
    setLoading(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPaymentHandler(stripe);
    setOptions({
      payment_method: {
        card: elements.getElement('card'),
      },
    });
    if (cardElementComplete && cardHolderComplete) {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardElementComplete, cardHolderComplete]);

  return (
    <div className={styles.container}>
      <CardElement
        className={styles.input}
        onChange={({ complete }: any) => {
          setCardElementComplete(complete);
        }}
      />

      <input
        required
        className={styles.input}
        value={name}
        onChange={({ target: { value } }) => {
          value.length > 2 && setCardHolderComplete(true);
          setName(value);
        }}
        placeholder={tr(t, 'stripe_name-of-holder')}
      />
    </div>
  );
};

export default injectStripe(StripeInfo);
